// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input, select {
  width: 100% !important;
}

.report-values .form-group {
  align-items: center;
}

.report-values {
  margin-left: 2%;
}

.card {
  border-radius: 0;
  padding-top: 1% !important;
  padding-bottom: 1% !important;
  overflow: hidden;
}

.card-container {
  overflow: hidden;
}

.show {
  opacity: 1;
}

.hide-data {
  opacity: 0;
}

.card-body {
  overflow-x: hidden;
  overflow-y: scroll;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 2% !important;
  padding-right: 1% !important;
}

.card-header {
  background: transparent;
  border: none;
}

.text-danger {
  height: 8px;
  padding-top: 4px;
  font-family: Inter;
  font-style: normal;
  font-size: 12px;
  letter-spacing: -0.0686271px;
}

.no-error-input {
  margin-bottom: 12px;
}

.w-80 {
  width: 72%;
  margin-left: 14%;
}

.card-header, .card-footer {
  border: 0;
  background: white;
}

.report-form-container {
  padding: 0;
  overflow: hidden !important;
}

.dialogTitle {
  border-bottom: 1px solid black;
  width: 100%;
}

.width100 {
  width: 100%;
}

.list {
  padding-top: 0;
}

.btn {
  margin-left: 10px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.card-width {
  width: 49%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
